import React, { Suspense, useRef, useState } from "react";
import {
  Dialog,
  DialogContent,
  Toaster,
  ToastProvider,
} from "@bandit-network/react-ui-kit";
// import { WalletKitProvider } from "@bandit-network/react-wallet-kit";
import { QuestWidgetView } from "./QuestWidgetView";
import { QuestContextProvider } from "../context/QuestContext";
import { useBanditContext } from "../context/BanditQuestContext";
import { UserProvider } from "../context/UserContext";

const WalletKitProvider = React.lazy(() =>
  import("@bandit-network/react-wallet-kit").then((module) => ({
    default: module.WalletKitProvider,
  })),
);

export interface WalletSettings {
  customSignature?: boolean;
  signature?: string;
}

export type QuestMode = "default" | "quest_only";

interface QuestWidgetProps {
  collectionId: number;
  isOpen: boolean;
  dialog?: boolean;
  onClose: () => void;
  showLeaderBoard?: boolean;
  showParticipants?: boolean;
  mode?: QuestMode;
}

const QuestWidget: React.FC<QuestWidgetProps> = ({
  collectionId,
  dialog = true,
  isOpen,
  onClose,
  showLeaderBoard = true,
  showParticipants = true,
  mode = "default",
}) => {
  const { cluster, apiKey, walletSettings } = useBanditContext();
  const ref = useRef();
  if (!dialog) {
    return (
      <div className="bad-quest__container">
        <ToastProvider>
          <Suspense fallback={null}>
            {/*// @ts-ignore*/}
            <WalletKitProvider
              cluster={cluster}
              inheritEvmWallets={walletSettings?.inheritEvmWallets}
              inheritSolWallets={walletSettings?.inheritSolWallets}
            >
              <QuestContextProvider
                apiKey={apiKey}
                cluster={cluster}
                questId={collectionId}
              >
                <UserProvider>
                  <QuestWidgetView
                    showLeaderBoard={showLeaderBoard}
                    showParticipants={showParticipants}
                    mode={mode}
                    onCloseModal={onClose}
                  />
                </UserProvider>
              </QuestContextProvider>
            </WalletKitProvider>
          </Suspense>
          <Toaster />
        </ToastProvider>
      </div>
    );
  }

  return (
    <ToastProvider>
      <div ref={ref} />
      <Dialog open={isOpen} onOpenChange={onClose} modal={false}>
        <DialogContent
          onPointerDownOutside={(e) => e.preventDefault()}
          className="bad-quest__dialog--content"
          onEscapeKeyDown={(e) => e.preventDefault()}
          container={ref.current}
        >
          <Suspense fallback={null}>
            {/*// @ts-ignore*/}
            <WalletKitProvider
              cluster={cluster}
              inheritEvmWallets={walletSettings?.inheritEvmWallets}
              inheritSolWallets={walletSettings?.inheritSolWallets}
            >
              <QuestContextProvider
                apiKey={apiKey}
                cluster={cluster}
                questId={collectionId}
              >
                <UserProvider>
                  <QuestWidgetView
                    showLeaderBoard={showLeaderBoard}
                    showParticipants={showParticipants}
                    mode={mode}
                    onCloseModal={onClose}
                  />
                </UserProvider>
              </QuestContextProvider>
            </WalletKitProvider>
          </Suspense>
        </DialogContent>
      </Dialog>
      <Toaster />
    </ToastProvider>
  );
};

export { QuestWidget };
